import React from 'react';
import Link from 'next/link';

import { NYCLandingType } from '@utils/types/landings';
import ImageWithLoader from '@components/_shared/imageWithLoader';
import { useGetListingLink } from '@utils/hooks/useGetListingLink';

import styles from './styles.module.scss';

const FourListings = (props: { listings: NYCLandingType['fourListings'] }) => {
  const { listings } = props;
  const { prepareListingHref } = useGetListingLink();

  return (
    <div className={styles.fourListings}>
      {listings.map((l) => {
        const link = l.listing
          ? prepareListingHref({
              listingSlug: l.listing[0]?.url_slug,
            })
          : '';
        const title = l.title || (l.listing ? l.listing[0]?.listingTitle : '');

        return (
          <Link href={link} key={l._key}>
            <a className={styles.fourListings__container}>
              <ImageWithLoader
                containerStyle={styles.fourListings__image}
                src={l.image}
                alt="First Image"
                sizes="(max-width: 1024px) 100vw,
                       35vw"
              />

              <div className={styles.fourListings__title}>{title}</div>
            </a>
          </Link>
        );
      })}
    </div>
  );
};

export default FourListings;
